<template>
  <v-main class="pa-4" fluid>
    <v-row >

      <v-snackbar v-model="snackbar" :timeout="8000" top :color="color" >  {{text}}
        <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
      </v-snackbar>

      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-h5 font-weight-bold"> Salidas </span>
            <v-spacer></v-spacer>
            <v-btn color="success" dark class="mr-2" @click="exportarInformacion()"> <v-icon>mdi-microsoft-excel</v-icon></v-btn>
            <v-btn color="primary" dark class="mr-2"  @click="nuevaSalida = true"> Nuevo </v-btn>
            <v-btn color="secondary" dark fab small  class="mr-2" @click="initialize()">  <v-icon>mdi-refresh</v-icon> </v-btn>

          </v-card-title>

          <v-card-text>
            <v-row >

              <v-col cols="12" sm="4" md="3" lg="2">
                <v-autocomplete
                  :items="bodegas" 
                  v-model="bodegafiltro" 
                  item-text="nombre" 
                  item-value="idbodegas" 
                  label="Bodegas" 
                  dense filled 
                  hide-details 
                  return-object
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="4" md="2" lg="2" class="pb-0">
                <v-text-field
                  dense
                  v-model="inicio"
                  label="Fecha de inicio"
                  hide-details
                  type="date"
                  filled
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="4" md="2" lg="2" class="pb-0">
                <v-text-field
                  dense
                  v-model="fin"
                  label="Fecha de fin"
                  hide-details
                  type="date"
                  filled
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3">
                <v-btn color="info" @click="filtroFechas()"  class="mr-2"><v-icon>search</v-icon></v-btn>
                <v-btn color="accent" @click="initialize()" >Todo</v-btn>
              </v-col>

              <v-spacer></v-spacer>
              <v-col cols="12" md="4" lg="3">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  dense
                  hide-details
                  append-icon="mdi-magnify" 
                  v-model="search"
                  clearable
                  filled
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="salidas"
                  :height="tamanioPantalla"
                  fixed-header
                  hide-default-footer
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                  :loading ="loading"
                  :search="search"
                  dense
                >
                  <template v-slot:item.FECHA_SALIDA="{ item }">
                    {{ moment(item.FECHA_SALIDA).format('LL') }}
                  </template>

                  <template v-slot:item.editar="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item)"  color="blue">  mdi-pencil </v-icon>
                  </template>
                
                </v-data-table>

              </v-col>
            </v-row>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
        </v-card>

        <v-dialog v-model="nuevaSalida" max-width="500px">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card class="pa-1">
              <v-toolbar flat class="">
                <div class="font-weight-black text-md-h6 text-xs-subtitle-1 "> {{  formTitle }}  </div>
                <v-spacer></v-spacer>
                <v-btn color="error" fab small elevation="1" @click="nuevaSalida = false" ><v-icon>clear</v-icon></v-btn>
              </v-toolbar>

              <!-- <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title> -->


              <v-card-text class="pb-0">
                <v-row>
                  <v-col cols="12" class="pb-0">
                    <v-autocomplete
                      v-model="producto"
                      :items="productos"
                      label="Producto"
                      return-object
                      item-text="nomart"
                      item-value="id"
                      :rules="[v => !!v || 'Campo requerido']"
                      outlined
                      dense
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" class="pb-0">
                    <v-autocomplete
                      :items="bodegas" 
                      v-model="bodega" 
                      item-text="nombre" 
                      item-value="idbodegas" 
                      label="bodegas" 
                      dense outlined 
                      return-object
                      :rules="[v => !!v || 'Campo requerido']"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="cant"
                      outlined
                      dense
                      type="number"
                      label="Cantidad"
                      :rules="[v => !!v || 'Campo requerido']"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      outlined
                      dense
                      v-model="fechaentr"
                      label="Fecha de salida"
                      type="date"
                      :rules="[v => !!v || 'Campo requerido']"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-autocomplete
                      :items="usuarios" 
                      v-model="usuario" 
                      item-text="nombre" 
                      item-value="idusuariosweb" 
                      label="Quien recibio" 
                      dense  
                      outlined
                      return-object
                      :rules="[v => !!v || 'Campo requerido']"
                    ></v-autocomplete>

                    <!-- <v-text-field
                      outlined
                      dense
                      v-model="recibio"
                      label="Recibió"
                      :rules="[v => !!v || 'Campo requerido']"
                    ></v-text-field> -->
                  </v-col>
                </v-row>


              </v-card-text>

              <div class="mt-10"></div>

              <v-footer absolute >
                <v-spacer></v-spacer>
                <v-btn class="primary" @click="save()"> Guardar salida </v-btn>
              </v-footer>

              <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="nuevaSalida = false"> Cancelar </v-btn>
                <v-btn color="blue darken-1" text @click="save()" > Guardar  </v-btn>
              </v-card-actions> -->
            </v-card>
          </v-form>
        </v-dialog>

      </v-col>

    </v-row>
  </v-main>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import  metodos from '@/mixins/metodos.js';
  import moment from 'moment'

  import XLSX from 'xlsx'
  
  export default {
    mixins:[metodos],

    data: () => ({
      nombre: 'Salidas',
      inicio:moment().subtract(1, 'months').startOf('month').format("YYYY-MM-DD"), 
      fin:  moment().subtract('months').endOf('months').format("YYYY-MM-DD"),

      menu: false,
      menu2: false,

      loading: true,
      longitud:5,
      page: 1,
      pageCount: 0,
      itemsPerPage: 80,
      search:'',
      salidas:[],
      headers: [
        { text: 'Articulo', align: 'left',sortable: false, value: 'NOMBRE_PRODUCTO'},
        { text: 'Cantidad',  value: 'CANTIDAD' },
        { text: 'Salida',    value: 'FECHA_SALIDA' },
        { text: 'Bodega',    value: 'BODEGA' },
        // { text: 'Recibió',   value: 'USUARIO_RECIBIO' },
        // { text: 'Entrego',   value: 'USUARIO_ENTREGO' },

      ],

      productos:[],
      producto:null,

      valid: true,
      search:'',
      text:'',
      color:'',
      snackbar: false,
      nuevaSalida: false,
      dialogDelete: false,
      categorias: [],
      editedIndex: -1,
      editedItem: {
        idlaboratorios:0,
        nomlab: '',
        estatus: 0,
      },
      defaultItem: {
        idlaboratorios:0,
        nomlab: '',
        estatus: 0,
      },

      // salidas:[],
      producto:null,
      cant:'',
      fechaentr:new Date().toISOString(),
      recibio:'',

      usuario:{ idusuariosweb: null, nombre: ''},
      usuarios:[],

      bodegas:[],
      bodega:{idbodegas:null, nombre:''},
      bodegafiltro: {idbodegas:null, nombre:''},

    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva salida' : 'Editar salida'
      },
      ...mapGetters('Login', ['getdatosUsuario', 'getLogeado']),
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    async created(){
      this.initialize();
      this.usuarios = await this.consultar_usuarios_administrativos();
      this.bodegas = await this.consultar_bodegas();
      this.productos = await this.consultar_producto_almacen();

    },
    methods:{

      initialize(){
        this.loading = true;
        this.salidas= [];

        this.$http.get('salidas.list').then(response =>{
          if(response == null){
            this.loading = false
            this.salidas = []
          }else{
            this.loading = false
            this.salidas = response.body
            this.salidas.forEach(element=>{
              element.fecha = element.fecha
            })
            this.longitud = this.salidas.length
          }
        })
      },

      existencias(){
        this.$http.get('existencias.codigo/' + this.codigo2).then(response =>{
          if(response == null){
            this.loading = false
            this.productos = []
          }else{
            this.loading = false
            this.productos = response.body
            this.longitud = this.productos.length
          }
        })
      },

      filtroFechas(){
        console.log('bodega', this.bodegafiltro);
        this.salidas= []
        var payload = {
          inicio: this.inicio,
          fin:    this.fin,
          idbodegas: !this.bodegafiltro ? 0 : this.bodegafiltro.idbodegas
        }
        this.$http.post('salidas.fecha',payload).then(response =>{
          if(response == null){
            this.loading = false
            this.salidas = []
          }else{
            this.loading = false
            this.salidas = response.body
            this.longitud = this.salidas.length
          }

          this.salidas.forEach(element=>{
            element.fecha = element.fecha
          })
        })
      },

      editItem (item) {
        this.editedIndex = this.categorias.indexOf(item)
        this.editedItem = Object.assign({}, item)
        console.log(this.editedItem)
        for(const i in this.productos){
          if(this.productos[i].codigo == this.editedItem.codigo){
            this.producto = this.productos[i]
          }
        }
        this.cant      = this.editedItem.CANTIDAD
        this.cant      = this.editedItem.CANTIDAD
        this.fechaentr = this.editedItem.FECHA_ENTRADA
        this.nuevaSalida = true
      },

      close () {
        this.nuevaSalida = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },


      save () {
        if(this.$refs.form.validate()){
          if(this.cant > this.producto.cant){
            this.text  = 'No puedes darle salida a: ' + this.cant + ' ya que solo tienes: ' + this.producto.cant
            this.snackbar = true
            this.color = 'error'
          }else{
            this.editedItem.estatus == false ? 0 : 1

            if (this.editedIndex > -1) {
              
            } else {
              var payloadSalida = {
                codigo:    this.producto.codigo,
                cant:      this.cant,
                recibio:   this.usuario.idusuariosweb,
                fecha:     this.traerFechaActual(),
                idbodegas: this.bodega.idbodegas,
                entrego:   this.getdatosUsuario.idusuariosweb
              }
              this.$http.post('salidas.add', payloadSalida).then(response=>{
                let payload2 = {idalmacen: this.producto.idalmacen, cant: this.producto.cant - this.cant}
                this.$http.put('almacen.update/' + this.producto.idalmacen, payload2).then(response=>{
                  this.text  = 'Salida exitosa'
                  this.snackbar = true
                  this.color = 'green'
                  this.initialize()
                })
              })
            }
            this.nuevaSalida = false 
          }
        }
      },

      exportarInformacion() {
        this.exportToExcel(this.salidas, this.nombre)
      },


    },

  }
</script>





